import React from "react";
import { Link } from "react-router-dom";
import { FilePlus2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { RiskBadge } from "@/components/risk/RiskBadge";
import { EmptyState } from "@/components/common/EmptyState";

export const RecentAssessments = ({ recent }) => (
  <div className="rounded-xl border bg-card lg:col-span-2">
    <div className="flex items-center justify-between border-b px-5 py-4">
      <h3 className="font-display text-base font-semibold">Recent assessments</h3>
      <Link to="/app/history" className="flex items-center gap-1 text-sm text-primary hover:underline" data-testid="view-all-history-link">View all <ArrowRight className="h-3.5 w-3.5" /></Link>
    </div>
    {recent.length === 0 ? (
      <div className="p-6">
        <EmptyState title="No assessments yet" description="Create your first booking risk assessment to see it here."
          action={<Link to="/app/new"><Button className="gap-2"><FilePlus2 className="h-4 w-4" /> New assessment</Button></Link>} />
      </div>
    ) : (
      <div className="divide-y" data-testid="recent-assessments-list">
        {recent.map((a) => (
          <Link key={a.id} to={`/app/result/${a.id}`} className="flex items-center justify-between px-5 py-3.5 transition-colors hover:bg-accent/40">
            <div className="min-w-0">
              <p className="truncate text-sm font-medium">{a.guest_initials || "—"} · <span className="text-muted-foreground">{a.platform}</span></p>
              <p className="text-xs text-muted-foreground">{a.property_name || "No property"} · {new Date(a.created_at).toLocaleDateString()}</p>
            </div>
            <div className="flex items-center gap-3">
              <span className="font-display text-lg font-semibold tabular-nums">{a.overall_score}</span>
              <RiskBadge band={a.risk_band} size="sm" />
            </div>
          </Link>
        ))}
      </div>
    )}
  </div>
);
